import { render, staticRenderFns } from "./CorrespondenceItemCreateButton.vue?vue&type=template&id=78bd12b7"
import script from "./CorrespondenceItemCreateButton.vue?vue&type=script&lang=js"
export * from "./CorrespondenceItemCreateButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports